import React, { useState, useEffect, useCallback,useRef  } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Layout from '../Layouts/pageLayout';
import Navbar from "../components/navbarCategory";
import Breadcrumbs from '../components/breadcrumbs';
import StyledFlickity from '../components/styledFlickity';
import api, { shopapi } from '../components/setAxios';
import CreateComment from '../components/CreateComment';
import config, { formaturl, formatDate } from '../config/staticData';
import ScrollToTop from '../components/scrollToTop';
import SEOPAGE,{HELMETSEO,BREADSEO} from '../components/seopage';
import POLL from '../components/poll';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function Post() {
    let { code, name } = useParams();
    const navigate = useNavigate();
    const contentRef = useRef(null);
    const [blog, setBlog] = useState(null);
    const [blogs, setBlogs] = useState([]);
    const [products, setProducts] = useState([]);
    const [comments, setComments] = useState([]);
    const [category, setCategory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingComments, setLoadingComments] = useState(true);
    const [LoadingCategory, setLoadingCategory] = useState(true);
    const [isLoading, setIsLoading] = useState(true); 

    
    const isSixDigitCode = (code) => {
        const sixDigitPattern = /^\d{6}$/;
        return sixDigitPattern.test(code);
    };

    const fetchBlogData = useCallback(async () => {
        setIsLoading(true); // تنظیم وضعیت بارگذاری به true
        try {
            let refID;
            let fetchedBlog;

            const response = await api.get(`/blog/GetBlog/${code}`);
            fetchedBlog = response.data;
            setBlog(fetchedBlog);

            // fetchProducts(fetchedBlog.id); 
            // fetchCategory(fetchedBlog.id);
            
            const correctName = formaturl(fetchedBlog.title);
            if (isSixDigitCode(code)) {
                navigate(`/blog/${fetchedBlog.id}/${correctName}`, { replace: true });
            } else {
                if (!name || name !== correctName || window.location.pathname === `/blog/${code}`) {
                    if (!name || window.location.pathname === `/blog/${code}`) {
                        navigate(`/blog/${code}/${correctName}`, { replace: true });
                    } else {
                        navigate(`/blog/${code}/${correctName}`, { replace: true });
                    }
                }
            }

            const relationResponse = await api.get("/blog/GetBlogsByRelationTypeAsync/blogCategory");
            setBlogs(relationResponse.data);
            
        } catch (error) {
            console.error("خطا در دریافت داده‌ها:", error);
        } finally {
            setLoading(false);
            setIsLoading(false); // تنظیم وضعیت بارگذاری به false
        }
    }, [code, name, navigate]);

    const fetchComments = useCallback(async (blogId) => {
        setLoadingComments(true);
        try {
            const commentResult = await api.get(`Comment/GetBlogComment/${blogId}`);
            if (commentResult && commentResult.status === 200 && commentResult.data) {
                setComments(commentResult.data);
            } else {
                setComments([]); // اگر دیتا نبود، آرایه خالی
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.log("کامنتی برای این مقاله وجود ندارد.");
                setComments([]);
            } else {
                console.error("خطای دریافت کامنت‌ها:", error);
            }
        } finally {
            setLoadingComments(false);
        }
    }, []);
    
    

    const fetchProducts = useCallback(async (blogId) => {
        try {
            const productResult = await api.get(`product/GetProduct/${blogId}`);
            if (productResult && productResult.status === 200 && productResult.data && Object.keys(productResult.data).length > 0) {
                setProducts(productResult.data);
            } else {
                setProducts([]); // اگر دیتا نبود، آرایه خالی
                console.log("محصولی یافت نشد.");
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.log("محصولی برای این مقاله وجود ندارد.");
                setProducts([]); // آرایه خالی برای جلوگیری از خطاهای بعدی
            } else {
                console.error("خطای غیرمنتظره:", error);
            }
        }
    }, []);
    
    const fetchCategory = useCallback(async (blogId) => { 
        setLoadingCategory(true);
        try {
            const categoryResult = await api.get(`product/GetProductCategory/${blogId}`); 
            if (categoryResult && Object.keys(categoryResult.data).length > 0) {
                setCategory(categoryResult.data);
            } else {
                console.log("محصولی یافت نشد.");
                setLoadingCategory(false);
            }
        } catch (error) {
            console.error("خطا در دریافت گروه:", error);
            setLoadingCategory(false);
        } finally {
            setLoadingCategory(false);
            
        }
    }, []);

    useEffect(() => {
        fetchBlogData();
    }, [fetchBlogData]);

    useEffect(() => {
        if (blog) {
            // fetchComments(blog.id);
        }
    }, [blog, fetchComments]);

    const setContentRef = useCallback((node) => {
        if (node !== null) {
          contentRef.current = node;
          const sections = node.querySelectorAll('div.product-sec');
          sections.forEach((section, index) => {
            if (products[index]) {
              section.innerHTML = `
                  <div class='product_sec_img' column>
                    <a href='https://www.toorangco.com/product/${products[index].productID}/${formaturl(products[index].productTitle)}' target="_blank" rel="noopener noreferrer" ></a>
                    <img src='${config.productPath}${products[index].productFile}' alt='${products[index].productTitle}' loading="lazy" />
                  </div>
                  <div class='product_sec_details column'>
                    <a href='https://www.toorangco.com/product/${products[index].productID}/${formaturl(products[index].productTitle)}' class='product-cta-title' target="_blank" rel="noopener noreferrer">${products[index].productTitle}</a>
                    <div class='product_sec_price'>
                        <span>${products[index].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان</span>
                        <div class='srp-button'>
                            <a href='https://www.toorangco.com/product/${products[index].productID}/${formaturl(products[index].productTitle)}' class='btn' target="_blank" rel="noopener noreferrer" >مشاهده و خرید</a>
                        </div>
                    </div>
                  </div>
              `;
            }
          });
        }
    }, [products]);
    
    if (isLoading) {
        return (
            <Layout header={Navbar}>
                <section className='subcategory'>
                    <div className="subAside">
                        <ul className="stick-menu">
                            <li className="stick-item">
                            </li>
                        </ul>
                    </div>
                    <div className='subBody clearfix'>
                        <Breadcrumbs />
                        <Skeleton height={800} />
                    </div>
                    <div className='subSide'>
                    </div>
                </section>
            </Layout>
        );
    }

  

    const Comment = ({ comment, comments,blogId, onCommentSubmitted, isChild }) => {
        const [activeReplyForm, setActiveReplyForm] = useState(null);
        const childComments = comments.filter(c => c.parentID === comment.id);
        const { jalaliDate } = formatDate(comment.createDate);

        const adminEmail = "admin@toorangco.com";

        const toggleReplyForm = (id) => {
            setActiveReplyForm((prev) => (prev === id ? null : id));
        };
    
        return (
            <div className={isChild ? 'child-comment' : ''}>
                <div className="comment-user">
                    <div className="comment-user-data">
                        <i className="fa-regular fa-circle-user"></i>
                        <div>{comment.name === adminEmail ? "مدیر سایت" : comment.name}</div>
                    </div>
                    <div className="comment-user-date">
                        <i className="fas fa-clock"></i>
                        <div>{jalaliDate}</div>
                    </div>
                    <div className="comment-social">
                        <i className="fa-solid fa-reply"></i>
                    </div>
                </div>
                <div className="commentChild-body">
                    <div className="comment-body">{comment.note}</div>
                    <div className="comment-reply">
                    {!isChild && (
                        <>
                        <button onClick={() => toggleReplyForm(comment.id)} className="btn btn-comment-reply">ارسال پاسخ</button>
                        {activeReplyForm === comment.id && ( 
                           <CreateComment
                                blogId={blogId}
                                parentId={comment.id} // ارسال parentID به عنوان والد
                                onCommentSubmitted={onCommentSubmitted}
                            />
                        )}
                        </> 
                    )}
                    </div>
                </div>
                {childComments.length > 0 && (
                    <div>
                        {childComments.map((childComment) => (
                            <Comment
                                key={childComment.id}
                                comment={childComment}
                                comments={comments}
                                blogId={blogId}
                                onCommentSubmitted={onCommentSubmitted}
                                isChild={true}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    };
    

    const CommentList = ({ comments, blogId, onCommentSubmitted }) => {
        const rootComments = comments.filter(comment => comment.parentID === null || comment.parentID === 0);

        return (
            <div>
                {rootComments.map((comment) => (
                <Comment key={comment.id} comment={comment} comments={comments} blogId={blogId} onCommentSubmitted={onCommentSubmitted} isChild={false} />
            ))}
            </div>
        );
    };

    return (
        <>
            <Layout header={Navbar}>
                <SEOPAGE
                    blogId={blog.id}
                    title={blog.title}
                    description={blog.metaDescription}
                    body={blog.description}
                    image={blog.blogPic}
                    video={blog.blogVideo}
                    videoDuration={blog.blogFileDuration}
                    publishDate={blog.publishDate}
                    ratingValue={comments.length}
                />
                <HELMETSEO
                    title={blog.urlTitle}
                    description={blog.metaDescription}
                    keyword={blog.keyword}
                    currentUrl={"https://www.toorangco.com/blog"}
                />
                <BREADSEO title={blog.title} pageUrl={`${process.env.REACT_APP_BASE_PATH}/${blog.id}/${formaturl(blog.title)}`} />
                
                <section className='subcategory'>
                    <div className="subAside">
                        <ul className="stick-menu">
                            <li className="stick-item">
                                <Link to={`${process.env.REACT_APP_BASE_PATH}/search`} className="stick-item-search">
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className='subBody clearfix'>
                        <Breadcrumbs blogID={blog.id} /> 
                        
                        <BlogDetail blog={blog} setContentRef={setContentRef} />

                        <div className="post_share">
                            <ul className="social-media-links post">
                                <li>
                                    <span className="social-sep"></span>
                                </li>
                                <li>
                                    <a
                                        href={`http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.origin + process.env.REACT_APP_BASE_PATH + '/' + blog.id + '/' + formaturl(blog.title))}&title=${encodeURIComponent(blog.title)}&summary=&source=`}
                                        target="_blank" rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-linkedin"></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.origin + process.env.REACT_APP_BASE_PATH + '/' + blog.id + '/' + formaturl(blog.title))}&t=${encodeURIComponent(blog.title)}`}
                                        target="_blank" rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.origin + process.env.REACT_APP_BASE_PATH + '/' + blog.id + '/' + formaturl(blog.title))}&text=${encodeURIComponent(blog.title)}`}
                                        target="_blank" rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-twitter"></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`https://wa.me/?text=${encodeURIComponent(window.location.origin + process.env.REACT_APP_BASE_PATH + '/' + blog.id + '/' + formaturl(blog.title))}%20${encodeURIComponent(blog.title)}`}
                                        target="_blank" rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-whatsapp"></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`https://t.me/share/url?url=${encodeURIComponent(window.location.origin + process.env.REACT_APP_BASE_PATH + '/' + blog.id + '/' + formaturl(blog.title))}&text=${encodeURIComponent(blog.title)}`}
                                        target="_blank" rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-telegram"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        
                        <POLL articleId={blog.id} />
                        
                        <CreateComment blogId={blog.id} onCommentSubmitted={() => fetchComments(blog.id)} />

                        {loadingComments ? <Skeleton count={1} height={300} /> : <CommentList comments={comments} blogId={blog.id} onCommentSubmitted={() => fetchComments(blog.id)} />}
                        
                    </div>
                    <div className='subSide'>
                        {LoadingCategory ? (
                                <Skeleton height={200} count={1} />
                            ) : (
                                category.length > 0 ? (
                                <RelatedProduct products={category} />
                                ) : (
                                    <p></p>
                                )
                            )}
                        {/* {blogs.length > 0 && <RelatedPosts blogs={blogs} />} */}
                    </div>
                    <ScrollToTop />
                </section>
            </Layout>
        </>
    );
}

function BlogDetail({ blog, setContentRef }) {
    return (
        <article className="special_blog">
            <h1>{blog.title}</h1>
            <AuthorDetails author={blog.author} authorPic={blog.authorPic} publishDate={blog.publishDate} />
            <BlogMedia video={blog.blogVideo} image={blog.blogPic} />

            <div ref={setContentRef}  className='post-content' dangerouslySetInnerHTML={{ __html: blog.description }} />

        </article>
    );
}

function AuthorDetails({ author, authorPic, publishDate }) {
    return (
        <div className="author">
            <img
                src={`${config.authorPath}${authorPic}`}
                alt={author}
                loading="lazy"
                onError={(e) => {
                    e.target.onerror = null; // جلوگیری از لوپ شدن
                    e.target.src = `${config.authorPath}toorang.jpg`; // به صورت رشته استفاده شود
                }}
            />
            <span>{author}</span>
            <p>{publishDate}</p>
        </div>
    );
}

function BlogMedia({ video, image }) {
    if (video && video.trim() !== '') {
        return (
            <video controls loading="lazy">
                <source src={`${config.videoPath}${video}`} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        );
    } else if (image) {
        // return <img src={`${config.blogPath}${image}`} className="blog-image" alt="Blog" loading="lazy" />;
        return '';
    }
    return null;
}

function RelatedPosts({ blogs }) {
    return (
        <div>
            <div className='title'>
                <span className='relatedBlog' >مطالب مرتبط</span>
            </div>
            <div className='sectionRelatedBlog' >
                {blogs.map((item) => (
                    <Link
                        key={item.id}
                        to={`${process.env.REACT_APP_BASE_PATH}/${item.id}/${formaturl(item.title)}`}
                        state={{ id: item.id }}
                    >
                        <article className="related-post">
                            <div className='related-post-item'>
                                <img src={`${config.blogPath}${item.blogPic}`} alt={item.title} loading="lazy" />
                                <div className='related-post-details'>
                                    <span className="detail-wrapper-title">{item.title}</span>
                                    <span className="detail-wrapper-time">{item.publishDate}</span>
                                </div>
                            </div>
                        </article>
                    </Link>
                ))}
            </div>
        </div>
    );
}

function RelatedProduct({ products }) {
    const flickitySuggestOptions = {
        pageDots: false,
        cellAlign: 'right',
        autoPlay: true,
        pauseAutoPlayOnHover: false,
        bgLazyLoad: true,
        draggable: true
    };

    const flickityVideoContent = products.map((item, index) => {
        return (
            <article key={index} className="suggest-card">
                <img src={`${config.productPath}${item.productFile}`} alt={item.productTitle} loading="lazy" />
                <span className='sug-title' >{item.productTitle}</span>
                <div className="srp-button">
                    <a href={`https://www.toorangco.com/product/${item.productID}/${formaturl(item.productTitle)}`} className='btn' target="_blank" rel="noopener noreferrer">مشاهده و خرید</a>
                </div>
            </article>
        );
    });

    return (
        <div>
            <div className='title'>
                <span className='product' >پیشنهادهایی برای شما</span>
            </div>
            <div className='suggestion' >
                <StyledFlickity flickityOptions={flickitySuggestOptions} flickityStyle={'carousel-suggest'} flickityContent={flickityVideoContent} />
            </div>
        </div>
    );
}

export default Post;
